<script>
import {ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import DatePicker from "vue3-persian-datetime-picker";
import Swals from "@/assets/js/Swals";
import FreeWorld from "@/assets/js/FreeWorld";
import persianDate from 'persian-date';

export default {
  name: "ReportingPage",
  components: {DatePicker, LoadingPage},
  setup(){

    let loading = ref(false)
    const today = new Date
    let today_date = ref(new persianDate(today).toLocale('en').format('YYYY-MM-DD'))
    let range_period = ref([])

    let info_today = ref({
      count: 0,
      price: 0,
      commission: 0,
      income: 0
    })
    let info_period = ref({
      count: 0,
      price: 0,
      commission: 0,
      income: 0
    })
    function reporting(type) {
      switch (type) {
        case 'today':
          if (today_date.value.length === 0){Swals.Warning('لطفا تاریخ مورد نظر خود را انتخاب کنید!');return false}
          loading.value = true
          FreeWorld.Heisenberg({today:today_date.value} , 'shop/report' , true).then((res)=>{
            loading.value = false
            info_today.value = res.data.report_today
          }).catch((res)=>{
            loading.value = false
            Swals.Catch(res , ()=>{reporting(type)})
          })
              break;

        case 'period':
          if (range_period.value.length === 0){Swals.Warning('لطفا تاریخ شروع و پایان گزارش گیری را انتخاب کنید!');return false}
          if (range_period.value.length !== 2){Swals.Warning('لطفا تاریخ شروع و پایان گزارش گیری را باهم انتخاب کنید!');return false}
          loading.value = true
              FreeWorld.Heisenberg({from:range_period.value[0],to:range_period.value[1]} , 'shop/report' , true).then((res)=>{
                loading.value = false
                info_period.value = res.data.period_info
              }).catch((res)=>{
                loading.value = false
                Swals.Catch(res , ()=>{reporting(type)})
              })
              break;
      }
    }
    reporting('today')

    return{

      loading,
      reporting,
      today_date,
      info_today,
      info_period,
      range_period,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">گزارشات مالی</p>
        <img onclick="window.history.back()" class="svg-arrow" src="../assets/img/arrow.svg" alt="">
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div class="w-100 p-body ">

      <div class="bg-white rounded-4 mb-4 p-2 shadow-custom">
        <p class="p-3 text-center bg-color text-white font-3 rounded-3 font-bold mb-3">درآمد روزانه</p>
        
        <p class="font-4 mb-2">انتخاب تاریخ</p>

        <div class="d-flex align-items-center justify-space-between mb-5">
          <div class="bg-main rounded-3 p-2 w-70">
            <date-picker v-model="today_date" format="jYYYY-jMM-jDD" display-format="jYYYY/jMM/jDD" dis class="text-center font-4 border-0 bg-main"></date-picker>
          </div>

          <v-btn @click="reporting('today')" class="p-2 bg-green rounded-3 h-100 w-25 text-white font-bold">گزارش</v-btn>
        </div>
        
        <div class="d-flex align-items-center justify-space-between mx-3">
          <p class="font-5 font-bold font-color">تعداد سفارش در این تاریخ</p>

          <p class="font-4 font-bold font-color-green">{{ info_today.count }}</p>
        </div>

        <div class="div_hr bg-color-blue-light my-3"></div>

        <div class="d-flex align-items-center justify-space-between mx-3">
          <p class="font-5 font-bold font-color">مبلغ کل سفارشات در این تاریخ</p>

          <p class="font-bold font-color-green d-flex align-items-center">
            <span class="font-4">{{ info_today.price.toLocaleString() }}</span>
            <span class="font-5 mr-1">تومان</span>
          </p>
        </div>

        <div class="div_hr bg-color-blue-light my-3"></div>

        <div class="d-flex align-items-center justify-space-between mx-3">
          <p class="font-5 font-bold font-color">کمیسیون اپلیکیشن در این تاریخ</p>

          <p class="font-bold font-color-green d-flex align-items-center">
            <span class="font-4">{{ info_today.commission.toLocaleString() }}</span>
            <span class="font-5 mr-1">تومان</span>
          </p>
        </div>

        <div class="div_hr bg-color-blue-light my-3"></div>

        <div class="d-flex align-items-center justify-space-between mx-3 mb-3">
          <p class="font-5 font-bold font-color">درآمد شما در این تاریخ</p>

          <p class="font-bold font-color-green d-flex align-items-center">
            <span class="font-4">{{ info_today.income.toLocaleString() }}</span>
            <span class="font-5 mr-1">تومان</span>
          </p>
        </div>

      </div>

      <div class="bg-white rounded-4 mb-4 p-2 shadow-custom">
        <p class="p-3 text-center bg-color text-white font-3 rounded-3 font-bold mb-3">گزارش گیری بازه ای</p>

        <p class="font-4 mb-1">انتخاب تاریخ</p>
        <p class="font-5 mb-2">(تاریخ شروع و پایان گزارش گیری را باهم انتخاب کنید)</p>

        <div class="d-flex align-items-center justify-space-between mb-5">
          <div class="rounded-3 p-2" :class="range_period.length > 0 ? 'w-16':'w-70 bg-main'">
            <date-picker v-model="range_period" clearable format="jYYYY-jMM-jDD" class="text-center font-4 border-0 bg-main" range></date-picker>
          </div>

          <div v-if="range_period.length > 0" class="w-60 z-1 d-flex justify-space-between align-items-center">
            <p class="rounded-3 text-center font-4">از</p>
            <p v-if="range_period[0]" class="p-2 bg-main rounded-3 text-center font-4">{{ range_period[0] }}</p>
            <p v-else class="p-2 bg-main rounded-3 text-center font-5">انتخاب نشده</p>
            <p class="rounded-3 text-center font-4">تا</p>
            <p v-if="range_period[1]" class="p-2 bg-main rounded-3 text-center font-4">{{ range_period[1] }}</p>
            <p v-else class="p-2 bg-main rounded-3 text-center font-5">انتخاب نشده</p>
          </div>

          <v-btn @click="reporting('period')" class="p-2 bg-green rounded-3 h-100 w-25 text-white font-bold">گزارش</v-btn>
        </div>

        <div class="d-flex align-items-center justify-space-between mx-3">
          <p class="font-5 font-bold font-color">تعداد سفارش در این تاریخ</p>

          <p class="font-4 font-bold font-color-green">{{ info_period.count }}</p>
        </div>

        <div class="div_hr bg-color-blue-light my-3"></div>

        <div class="d-flex align-items-center justify-space-between mx-3">
          <p class="font-5 font-bold font-color">مبلغ کل سفارشات در این تاریخ</p>

          <p class="font-bold font-color-green d-flex align-items-center">
            <span class="font-4">{{ info_period.price.toLocaleString() }}</span>
            <span class="font-5 mr-1">تومان</span>
          </p>
        </div>

        <div class="div_hr bg-color-blue-light my-3"></div>

        <div class="d-flex align-items-center justify-space-between mx-3">
          <p class="font-5 font-bold font-color">کمیسیون اپلیکیشن در این تاریخ</p>

          <p class="font-bold font-color-green d-flex align-items-center">
            <span class="font-4">{{ info_period.commission.toLocaleString() }}</span>
            <span class="font-5 mr-1">تومان</span>
          </p>
        </div>

        <div class="div_hr bg-color-blue-light my-3"></div>

        <div class="d-flex align-items-center justify-space-between mx-3 mb-3">
          <p class="font-5 font-bold font-color">درآمد شما در این تاریخ</p>

          <p class="font-bold font-color-green d-flex align-items-center">
            <span class="font-4">{{ info_period.income.toLocaleString() }}</span>
            <span class="font-5 mr-1">تومان</span>
          </p>
        </div>

      </div>

    </div>
  </div>

</template>


<style scoped>

.div_hr{
  width: 100%;
  height: 2px;
}
.w-16{
  width: 16%;
}

</style>